import ScrollTop from './ScrollTop';

export default ScrollTop;


// WEBPACK FOOTER //
// ./src/components/ScrollTop/index.tsx